import { render, staticRenderFns } from "./miniQuestionEditPop.vue?vue&type=template&id=06e13c34&scoped=true"
import script from "./miniQuestionEditPop.vue?vue&type=script&lang=js"
export * from "./miniQuestionEditPop.vue?vue&type=script&lang=js"
import style0 from "./miniQuestionEditPop.vue?vue&type=style&index=0&id=06e13c34&prod&lang=less"
import style1 from "./miniQuestionEditPop.vue?vue&type=style&index=1&id=06e13c34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e13c34",
  null
  
)

export default component.exports